import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup } from "@angular/forms";
import { BaseAgency, ENTITLEMENTS, EntitlementsHelperService, IndividualMarketAgency, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from "@ptl/account-management";
import { AuthoringModeService } from "src/app/shared/services/authoring-mode.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import {HTTPWrapperContext, REQUEST_METHODS, RequestConfigImplementation, XHR_STRATEGIES, AxwayTokenFetcherService} from '@ptl/xhr';
import {HttpHeaders} from '@angular/common/http';
import moment from 'moment';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

interface StaticReportsFormValues {
    agentIncludeSsn: boolean;
    agentIncludeMbi: boolean;
    agencyIncludeSsn: boolean;
    agencyIncludeMbi: boolean;
    agencyPreferredIncludeSsn: boolean;
    agencyPreferredIncludeMbi: boolean;
    agencyStandardIncludeSsn: boolean;
    agencyStandardIncludeMbi: boolean;
}
interface StaticReportsFormControls {
    agentIncludeSsn: AbstractControl;
    agentIncludeMbi: AbstractControl;
    agencyIncludeSsn: AbstractControl;
    agencyIncludeMbi: AbstractControl;
    agencyPreferredIncludeSsn: AbstractControl;
    agencyPreferredIncludeMbi: AbstractControl;
    agencyStandardIncludeSsn: AbstractControl;
    agencyStandardIncludeMbi: AbstractControl;
}
@Component({
    selector: 'app-static-reports-download',
    templateUrl: './static-reports-download.component.html',
    styleUrls: ['./static-reports-download.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StaticReportsDownloadComponent implements OnInit {

    @Input() forceHideProducerReport: string;
    @Input() forceHideAgencyReport: string;
    @Input() forceHideAgencyReportPreferred: string;
    @Input() forceHideAgencyReportStandard: string;
    @Input() forceHideProducerActivityReport: string;
    @Input() forceHideEnrollmentStatusReport: string;

    @Input() lineOfBusiness: string;


    hasEntitlements: boolean;
    content = {
        producerReport: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            },
            includeMbi: {
                text: '',
                name: ''
            }
        },
        agencyReport: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            },
            includeMbi: {
                text: '',
                name: ''
            }
        },
        agencyReport_preferred: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            }
        },
        agencyReport_standard: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            }
        },
        producerActivityReport: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            }
        },
        airrReport: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            }
        },
        enrollmentStatusReport: {
            title: '',
            show: true,
            text: '',
            description1: '',
            description2: '',
            download: '',
            includeSsn: {
                text: '',
                name: ''
            }
        }
    };

    lob: LINE_OF_BUSINESS_ENUM;
    loginData: UserInfoStateStructure;

    agencyType: 'Preferred Agency' | 'Standard Agency' | 'Sub-Standard Agency' | string;


    includeReportType = false;

    // User Type
    isUserAgent = true;
    hasGeneralAgencyAdmin = true;
    isUserInternal = true;
    agentHasACSIdValue = true;
    selectedAgency: BaseAgency;

    form: FormGroup;

    constructor(
        private entitlementService: EntitlementsHelperService,
        private authoringMode: AuthoringModeService,
        private reducerUtilityService: ReducerUtilityService,
        private entitlementsHelper: EntitlementsHelperService,
        private fb: FormBuilder,
        private httpClient: HTTPWrapperContext,
        private axwayTokenFetcherService: AxwayTokenFetcherService
    ) { }

    async ngOnInit() {


        /****
         * Load Teamsite Data
         ****/
        // teamsiteService.loadFile("indvBb").then(function (data) {
        //     this.content = data;
        // });
        if (this.lineOfBusiness === 'individual') {
            this.hasEntitlements = true;
        }

        this.lob = await this.entitlementService.getCurrentLobPromise();
        this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

        if (this.lineOfBusiness === 'medicare') {
            const hasSeniorMarketsEntitlement = await this.entitlementsHelper.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.SNR_MKTS_IND, this.lob, this.loginData?.userInfo?.role as USER_ROLE);
            if (hasSeniorMarketsEntitlement) {
                this.hasEntitlements = true;
            }
        }

        if (this.hasEntitlements) {

            this.isUserAgent = this.loginData?.userInfo.role.toLowerCase() === USER_ROLE.AGENT;

            this.hasGeneralAgencyAdmin = await this.entitlementsHelper.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.GENERAL_AGENCY_ADMIN, this.lob, this.loginData?.userInfo?.role as USER_ROLE);
            // this.hasGeneralAgencyAdmin = this.loginData?.userInfo.role.toLowerCase() === USER_ROLE.AGENCY_ADMIN;

            this.isUserInternal = this.loginData?.userInfo.role.toLowerCase() === USER_ROLE.INTERNAL;
        }

        this.selectedAgency = await this.entitlementService.getSelectedAgencyPromise();
        this.agencyType = (this.selectedAgency as IndividualMarketAgency).agencyType;

        this.agentHasACSIdValue = !!this.selectedAgency.agentACSId;

        this.updateDisplayForInputConfig();
        this.setupForm();
    }

    setupForm() {
        this.form = this.fb.group({
            agentIncludeSsn: this.fb.control(false),
            agentIncludeMbi: this.fb.control(false),
            agencyIncludeSsn: this.fb.control(false),
            agencyIncludeMbi: this.fb.control(false),
            agencyPreferredIncludeSsn: this.fb.control(false),
            agencyPreferredIncludeMbi: this.fb.control(false),
            agencyStandardIncludeSsn: this.fb.control(false),
            agencyStandardIncludeMbi: this.fb.control(false)
        })
    }
    get formValuesAsJson(): StaticReportsFormValues {
        return this.form.value as StaticReportsFormValues;
    }
    get formControls(): StaticReportsFormControls {
        return this.form.controls as unknown as StaticReportsFormControls;
    }

    updateDisplayForInputConfig() {
        if (this.forceHideProducerReport === "true") {
            this.content.producerReport.show = false;
        }
        if (this.forceHideAgencyReport === "true") {
            this.content.agencyReport.show = false;
        }
        if (this.forceHideAgencyReportPreferred === "true") {
            this.content.agencyReport_preferred.show = false;
        }
        if (this.forceHideAgencyReportStandard === "true") {
            this.content.agencyReport_standard.show = false;
        }
        if (this.forceHideProducerActivityReport === "true") {
            this.content.producerActivityReport.show = false;
        }
        if (this.forceHideEnrollmentStatusReport === "true") {
            this.content.enrollmentStatusReport.show = false;
        }
    }

    downloadProducerReport() {

        let agencyList = this.loginData.userInfo.agencies;

        const agentACSId = this.selectedAgency.agentACSId;

        if (!agentACSId) {
            return;
        }

        let reportUrl = '/cmcrst/x-services/salesReport/agent/' + this.lineOfBusiness + '/';

        reportUrl += agentACSId;

        if (agencyList && agencyList.length === 1) {
            reportUrl = reportUrl + '/' + agencyList[0].agencyId; //agentACSId
        }

        if (this.formValuesAsJson.agentIncludeSsn) {
            reportUrl += ('?includeSsn=' + this.formValuesAsJson.agentIncludeSsn);
        }

        if (this.formValuesAsJson.agentIncludeMbi) {
            reportUrl += ("?includeMbi=" + this.formValuesAsJson.agentIncludeMbi);
        }

        window.open(reportUrl);
    };

    downloadPAR() {

        const agentACSId = this.selectedAgency.agentACSId;

        if (!agentACSId) {
            return;
        }

        let reportUrl = '/cmcrst/x-services/salesReport/par/' + this.lineOfBusiness + '/';

        reportUrl += agentACSId;

        reportUrl = reportUrl + '/' + this.selectedAgency.agencyId;

        window.open(reportUrl);
    };

    downloadAgencyReport(reportType: 'STANDARD' | 'PREFERRED' | 'REGULAR' = 'REGULAR') {
        this.includeReportType = ['STANDARD', 'PREFERRED'].includes(reportType);

        // this.agencyIncludeMbi);
        // this.openBobModal();

        let reportServiceUrl = '/cmcrst/x-services/salesReport/agency/' + this.lineOfBusiness + '/';

        // TODO: this should find a preferred agency if it is a standard agency?
        const currentAgencyId = this.getAgencyForReport(); //this.selectedAgency.agencyId;

        reportServiceUrl += currentAgencyId;

        // Start query params
        if (this.formValuesAsJson.agencyIncludeSsn
            || this.formValuesAsJson.agencyPreferredIncludeSsn
            || this.formValuesAsJson.agencyStandardIncludeSsn
            || this.formValuesAsJson.agencyIncludeMbi
            || this.formValuesAsJson.agencyPreferredIncludeMbi
            || this.formValuesAsJson.agencyStandardIncludeMbi
            || (this.includeReportType)) {
            reportServiceUrl += "?";
        }

        if (this.formValuesAsJson.agencyIncludeSsn || this.formValuesAsJson.agencyPreferredIncludeSsn || this.formValuesAsJson.agencyStandardIncludeSsn) {
            // if there's already a query param....
            if ((reportServiceUrl.indexOf("?") !== -1) && (reportServiceUrl.indexOf("?") < reportServiceUrl.length - 1)) {
                reportServiceUrl += "&";
            }

            reportServiceUrl += "includeSsn=true";
        }

        if (this.formValuesAsJson.agencyIncludeMbi || this.formValuesAsJson.agencyPreferredIncludeMbi || this.formValuesAsJson.agencyStandardIncludeMbi) {

            if ((reportServiceUrl.indexOf("?") !== -1) && (reportServiceUrl.indexOf("?") < reportServiceUrl.length - 1)) {
                reportServiceUrl += "&";
            }

            reportServiceUrl += "includeMbi=true";
        }

        if (this.includeReportType) {

            if ((reportServiceUrl.indexOf("?") !== -1) && (reportServiceUrl.indexOf("?") < reportServiceUrl.length - 1)) {
                reportServiceUrl += "&";
            }

            reportServiceUrl += `agencytype=${reportType}`;
        }

        window.open(reportServiceUrl);

    };

    async downloadESReport(): Promise<any> {

        const agentACSId = this.selectedAgency?.agentACSId;


        let queryParameters = {
            beginDate: null,
            endDate: null,
            planName: null,
            applicationStatus: null,
            productType: null,
            agency: this.selectedAgency.agencyId || null,
            userType: this.loginData?.basicUserInfo?.userType || null,
            agentId: this.loginData?.userInfo?.agentId || null,
            agentACSId: agentACSId || null,
            userId: this.loginData?.basicUserInfo.userId || null,
            gaaEntitlement: this.hasGeneralAgencyAdmin
        };

      //console.log('test ',mnESReportUrl);
      /*let addParameterToURL = function (key: string, value: any) {
          mnESReportUrl += (mnESReportUrl.split('?')[1] ? '&' : '?') + key + '=' + value;
      };

      if (queryParameters.agentId) {
          addParameterToURL('agentId', queryParameters.agentId);
      }

      if (queryParameters.userType) {
          addParameterToURL('userType', queryParameters.userType);
      }

      if (queryParameters.userId) {
          addParameterToURL('userId', queryParameters.userId);
      }

      if (queryParameters.gaaEntitlement) {
          addParameterToURL('gaaEntitlement', queryParameters.gaaEntitlement);
      }

      if (queryParameters.agency) {
          addParameterToURL('agency', queryParameters.agency);
      }

      if (queryParameters.agentACSId) {
          addParameterToURL('agentACSId', queryParameters.agentACSId);
      }

      window.open(mnESReportUrl);*/

      let response = await this.makeRequest(queryParameters);
      this.saveByteArray(response);
    }

  saveByteArray(byte) {
    let blob = new Blob([byte], {type: "application/vnd.ms-excel"});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    let fileName = `MNEnrollmentStatusReport${moment().format('MMDDYYYY')}.xls`;
    link.download = fileName;
    link.click();
  }

  async makeRequest(queryParameters: any) {
    const host = window.location.hostname;
    let env = '';
    if (host.indexOf('env') >= 0) 
        env = 't' + host.substring(host.indexOf('env'), host.indexOf('.'));
      
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
    //   url: '/cmcsnr/x-services/mnenrollmentreport/getMNEnrollmentReport',
      url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.REPORTS.MN_ENROLLMENT_STATUS, {}),
      headers: new HttpHeaders({
        'x-hmhs-test-backend': `wasinter${env}.highmark.com`
      }),
      accept: 'application/vnd.ms-excel',
      responseType: 'blob',
      POST_OR_PUT_PAYLOAD: queryParameters
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpClient.makeRequest(requestConfig);
  }


    getAgencyForReport() {
        let currentAgencyId = this.determineAgencyByType();
        return currentAgencyId;
    }

    determineAgencyByType() {

        let currentAgencyId: string = this.selectedAgency.agencyId;

        let agencyType = (this.selectedAgency as IndividualMarketAgency).agencyType;

        if (this.isUserAgent
            && (agencyType === "Standard Agency" || agencyType === "Sub-Standard Agency")) {

            if (!this.selectedAgency.agentACSId || !this.selectedAgency.agencyPartyId) {
                /****
                 * If the selectedAgency active on the user lack agentACSId or agencyPartyId
                 * find another agency that has these values
                 * and use that found agency's agencyId
                 ****/
                let subAgenciesCheckedStandard = false;
                let allAgencyTypesChecked = true;

                while (allAgencyTypesChecked) {

                    for (let agencyIndex = 0; agencyIndex < this.loginData?.userInfo?.agencies.length; agencyIndex++) {

                        if (agencyType === "Sub-Standard Agency"
                            && this.loginData?.userInfo?.agencies[agencyIndex].agencyType === "Standard Agency"
                            && !subAgenciesCheckedStandard) {

                            if (this.loginData?.userInfo?.agencies[agencyIndex].agentACSId
                                && this.loginData?.userInfo?.agencies[agencyIndex].agencyPartyId) {

                                return this.loginData?.userInfo?.agencies[agencyIndex].agencyId;
                            }

                        } else if (agencyType === "Sub-Standard Agency"
                            && this.loginData?.userInfo?.agencies[agencyIndex].agencyType === "Preferred Agency"
                            && subAgenciesCheckedStandard) {

                            if (this.loginData?.userInfo?.agencies[agencyIndex].agentACSId
                                && this.loginData?.userInfo?.agencies[agencyIndex].agencyPartyId) {

                                return this.loginData?.userInfo?.agencies[agencyIndex].agencyId;
                            }

                        } else if (agencyType === "Standard Agency"
                            && this.loginData?.userInfo?.agencies[agencyIndex].agencyType === "Preferred Agency") {

                            if (this.loginData?.userInfo?.agencies[agencyIndex].agentACSId
                                && this.loginData?.userInfo?.agencies[agencyIndex].agencyPartyId) {

                                return this.loginData?.userInfo?.agencies[agencyIndex].agencyId;
                            }

                        }
                    }

                    if (subAgenciesCheckedStandard && agencyType === "Sub-Standard Agency") {
                        allAgencyTypesChecked = false;
                    }

                    if (agencyType === "Sub-Standard Agency") {
                        subAgenciesCheckedStandard = true;
                    }
                }
            }
        }

        return currentAgencyId;

    }

    // openBobModal(disableClose: boolean = false) {

    //     this.matDialog.open(BookOfBusinessModalComponent, {
    //         maxWidth: '900px',
    //         maxHeight: '200vh',
    //         data: {
    //             lineOfBusiness: this.lineOfBusiness,
    //             loginData: this.loginData,
    //             agencyIncludeSsn: this.agencyIncludeSsn,
    //             agencyPreferredIncludeSsn: this.agencyPreferredIncludeSsn,
    //             agencyStandardIncludeSsn: this.agencyStandardIncludeSsn,
    //             agencyIncludeMbi: this.agencyIncludeMbi,
    //             agencyPreferredIncludeMbi: this.agencyPreferredIncludeMbi,
    //             agencyStandardIncludeMbi: this.agencyStandardIncludeMbi,
    //             includeReportType: this.includeReportType,
    //             hasGeneralAgency: this.hasGeneralAgency,
    //             isStandardAgency: this.isStandardAgency
    //         }
    //     });
    // }

}
